export default "__VITE_ASSET__pIKaXoa5__"